import React, { useState } from 'react';

import { translations } from '../../locale/translations';
import { RE_EMAIL } from '../../utils/util';
import { SignUpProps } from '../Credentials';
import { Button, ErrorMessage, FormControl, Input, Link, SwitchPage, Title } from '../../styles/shared.styles';

export const ForgotPassword = ({ formState, setFormState, forgotPassword, lang, switchPage }: SignUpProps) => {
    const [showErrors, setShowErrors] = useState(false);
    const [currentError, setCurrentError] = useState('');
    const locale = translations[lang];

    const handleEmail = (e: React.ChangeEvent<HTMLInputElement>) => {
        setFormState({ email: e.target.value });
        setShowErrors(false);
    };

    const emailValid = RE_EMAIL.test(formState.email);

    function sendEmail() {
        if (!emailValid) {
            setCurrentError(locale.emailMissing);
            setShowErrors(true);

            return;
        }

        forgotPassword(formState.email).then(
            () => {
                setCurrentError(`${locale.forgotPasswordSuccess}:\n${formState.email}`);
                switchPage('SignIn');
            },
            (err) => {
                setShowErrors(true);
                setCurrentError((err as any).message);
            }
        );
    }

    return (
        <>
            <Title>{locale.forgotPassword}</Title>

            <FormControl required>
                <label>{locale.email}</label>
                <Input
                    autoCapitalize="off"
                    autoCorrect="off"
                    error={showErrors && !!currentError}
                    required
                    spellCheck={false}
                    type="email"
                    value={formState.email}
                    onChange={handleEmail}
                />
                {showErrors && currentError && <ErrorMessage>{currentError}</ErrorMessage>}
            </FormControl>

            <Button data-testid="reset-password" onClick={sendEmail}>
                {locale.resetPassword}
            </Button>

            <SwitchPage>
                <span>{locale.noNeedToResetPassword} </span>
                <Link tdata-estID="signin" onClick={() => switchPage('SignIn')}>
                    {locale.signIn}
                </Link>
            </SwitchPage>
        </>
    );
};
